<template>
  <div>
    <v-speed-dial v-model="fab" direction="right" absolute>
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="green" @click="onExport" v-if="!hideExport">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-database-export</v-icon>
          </template>
          Export Selected Records
        </v-tooltip>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="pink accent-1"
        @click="onUnExport"
        v-if="$store.getters.hasAccessTo('finances:unexport') && !hideUnexport"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-database-remove</v-icon>
          </template>
          Unexport Selected Records
        </v-tooltip>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="primary"
        @click="onExportAll"
        v-if="!hideExport"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-all-inclusive</v-icon>
          </template>
          Export All Records
        </v-tooltip>
      </v-btn>
      <v-btn fab dark small color="indigo" v-if="false">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <slot> </slot>
      <v-btn fab dark small color="red" v-if="false">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-delete</v-icon>
          </template>
          Remove Selected Records
        </v-tooltip>
      </v-btn>
    </v-speed-dial>
    <list-export
      :show="showExportSettings"
      @close="onExportClose"
      @export="onStartExport"
      :records="records"
      :columns="columns"
      :list="list"
      :filter="filter"
      :custom-filter="customFilter"
      :show-sage="showSage"
      @complete="onExportComplete"
      :custom-formats="customFormats"
    ></list-export>
    <div v-if="debug">
      <code>{{ filter }}</code>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ListExport from "./ListExport";
const UNEXPORT_LIST = gql`
  mutation unExportList($input: ListUnexportInput) {
    unExportList(input: $input) {
      success
      message
      error
    }
  }
`;
export default {
  name: "list-actions",

  props: {
    hideExport: {
      type: Boolean,
      default: () => false,
    },
    hideUnexport: {
      type: Boolean,
      default: () => false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: String,
      default: () => "",
    },
    filter: {
      type: Object,
      default: () => {},
    },
    customFilter: {
      type: Object,
      default: () => {},
    },
    showSage: {
      type: Boolean,
      default: () => false,
    },
    customFormats: {
      type: Array,
      default: () => [],
    },
  },

  components: { ListExport },

  data() {
    return {
      debug: false,
      fab: true,
      exportAll: false,
      showExportSettings: false,
    };
  },

  computed: {
    records() {
      return this.exportAll ? [] : [...this.selected];
    },
  },

  methods: {
    onRemoveSelected() {
      console.log("removing selected", this.selected);
    },
    async onUnExport() {
      try {
        const res = await this.$apollo.mutate({
          mutation: UNEXPORT_LIST,
          variables: {
            input: {
              name: this.list,
              recordsIds: this.records.map((r) => (r.node ? r.node.id : r.id)),
            },
          },
        });
        if (res.data.unExportList && res.data.unExportList.success) {
          this.$store.dispatch("showAppSnackbar", {
            msg: res.data.unExportList.message,
            color: "success",
          });
          this.$emit("update", res.data.unExportList);
        } else {
          this.$store.dispatch("showAppSnackbar", {
            msg: res.data.unExportList.message,
            color: "error",
          });
        }
      } catch (err) {
        console.log(err);
        const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
    onExport() {
      this.exportAll = false;
      this.showExportSettings = true;
    },
    onExportAll() {
      this.exportAll = true;
      this.showExportSettings = true;
    },
    onStartExport(settings) {
      this.showExportSettings = false;
    },
    onExportComplete(payload) {
      //console.log("export complete");
      this.$emit("update", payload);
    },
    onExportClose() {
      this.showExportSettings = false;
      this.$emit("close");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/list-actions/ListActions.vue